import React from "react";
import WiresActivityPage, { getDefaultData, getDefaultUI } from "components/pages/WiresActivityPage";
import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { WireActivity } from "model";

/**
 * @name Capture003WireApproved
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Activity".
 */
export default function Capture003WireApproved() {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const defaultData = getDefaultData();
    const defaultUI = getDefaultUI();
    const pendingTransfers = defaultData.pendingWireWidgetData.oneTimeWireTransfers;

    const checkedPendingTransfers = pendingTransfers.map(item => {
        if (item.id === 0) {
            item.isChecked = true;
        }

        return item;
    });

    const unCheckedPendingTransfers = checkedPendingTransfers.filter(item => !item.isChecked)

    const updatedWireActivity = checkedPendingTransfers.filter(item => item.isChecked).map((item, index) => {
        return WireActivity.init({
            ...item.record,
            id: parseInt(WireActivity.nextID()) + parseInt(index),
            payeeName: item.name,
            status: "1",
            statusDescription: "pending approval",
            fundingAccount: item.wireFundingAccount.id
        });

    }, []);

    const data = BCMSStateManagerCRUD.init(defaultData)
        .update(["pendingWireWidgetData", "oneTimeWireTransfers"], unCheckedPendingTransfers)
        .update(["wireActivityWidgetData", "wireActivity"], [...updatedWireActivity, ...WireActivity.initAll()])
        .submit();

    const ui = BCMSStateManagerCRUD.init(defaultUI)
        .update(["showWireApproveBanner"], true)
        .submit();

    return <WiresActivityPage data={data} ui={ui} />;
}